import { Controller } from "@hotwired/stimulus"

// Chart.defaults.global.colors[0] (#97BBCD), repeated here so this chart matches the rest;
// chart_defaults.js still sets the globals it inherits.
const SERIES_RGB = [151, 187, 205]

export default class extends Controller {
  static get targets() { return ["canvas"]; }
  static get values() { return { graph: Object }; }

  connect() {
    this.chart = new Chart(this.canvasTarget, {
      type: "bar",
      data: {
        labels: this.graphValue.dates,
        datasets: [{
          label: "User Counts",
          data: this.graphValue.user_counts,
          backgroundColor: this.seriesColor(0.2),
          borderColor: this.seriesColor(1)
        }]
      },
      options: { responsive: true, maintainAspectRatio: false }
    });
  }

  disconnect() {
    if (this.chart) { this.chart.destroy(); }
  }

  seriesColor(alpha) {
    return `rgba(${SERIES_RGB.concat(alpha).join(",")})`;
  }
}
